import { Head } from "../components/Head";

export default function NotFound() {
  return (
    <>
      <Head title="Siden findes ikke" desc="Siden blev ikke fundet." noindex />
      <div className="wrap" data-testid="not-found-page"><div className="ptop"><h1>Den side findes ikke</h1>
        <p className="lead">Måske er opskriften flyttet. Prøv at søge, eller gå til forsiden.</p>
        <p><a className="btn" href="/" data-testid="not-found-home-link">Til forsiden</a></p></div></div>
    </>
  );
}
